<template>
  <div class="statistics">
    <div class="newTime">本页更新于:{{ pageTime }}</div>
    <Total></Total>
    <div class="list-content bottom_distance">
      <Histogram></Histogram>
      <!-- <PieChart></PieChart> -->
    </div>
  </div>
</template>

<script>
import './statis.less'
import Histogram from './widgets/histogram'
import Total from './widgets/total'
import moment from 'moment'
export default {
  data() {
    return {
      pageTime: null,
    }
  },
  mounted() {
    this.pageTime = moment(new Date()).format('YYYY-MM-DD HH:mm')
    
  },
  components: {
    Histogram,
    Total,
  },
}
</script>
